/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Step_StageInputs */

const en_directory_ai_tools_studio_step_stage = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the stage`)
};

const zh_directory_ai_tools_studio_step_stage = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择舞台`)
};

/**
* | output |
* | --- |
* | "Pick the stage" |
*
* @param {Directory_Ai_Tools_Studio_Step_StageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_step_stage = /** @type {((inputs?: Directory_Ai_Tools_Studio_Step_StageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Step_StageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_step_stage(inputs)
	return zh_directory_ai_tools_studio_step_stage(inputs)
});
export { directory_ai_tools_studio_step_stage as "directory.ai_tools.studio.step_stage" }